import { ELanguage } from '@qapline/translations';
import { GlobeIcon, ISelectProps, Select } from '@qapline/ui';
import { useLanguage } from 'core/translation/hooks';

import styles from './LanguageSwitch.module.scss';

export const LanguageSwitch = () => {
    const { changeLanguage, i18n } = useLanguage();

    const options: ISelectProps<false>['options'] = [
        { value: ELanguage.cs, label: 'Čeština' },
        { value: ELanguage.en, label: 'English' },
    ];

    const handleChangeValue = (value: string | number) => {
        changeLanguage(value as ELanguage);
    };

    return (
        <Select
            prefix={<GlobeIcon className={styles.icon} height={24} width={24} />}
            className={styles.select}
            value={i18n.language}
            onValueChange={handleChangeValue}
            options={options}
        />
    );
};
